/** Bundled stock stills in /public/marketing (reliable vs hotlinked CDN). */
const marketingAsset = (filename) => `${process.env.PUBLIC_URL}/marketing/${filename}`;

export const DEMO_LIBRARY_VIDEO_THUMB = marketingAsset('demo-library-thumb.jpg');

export const DEMO_REVIEW_VIDEO_THUMB = marketingAsset('demo-review-thumb.jpg');

/** Pipeline demo — distinct from workflow library / review thumbs. */
export const DEMO_PIPELINE_MEDIA_THUMB = marketingAsset('demo-pipeline-media-thumb.jpg');
export const DEMO_PIPELINE_DRAFT_THUMB = marketingAsset('demo-review-frame-outdoor.jpg');

/** One still per review scrub breakpoint — intro, mid-cut, end card. */
export const DEMO_REVIEW_FRAME_STILLS = [
  marketingAsset('demo-review-thumb.jpg'),
  marketingAsset('demo-review-frame-outdoor.jpg'),
  marketingAsset('demo-review-frame-studio.jpg'),
];
